import { ReactNode, useCallback, useState } from 'react'

import { Flash, type FlashProps } from '@/ui'

import FlashContext from './FlashContext'

interface FlashProviderProps {
  children: ReactNode
}

type State = {
  open: boolean
  severity: FlashProps['severity']
  message: string
}

const defaultState = {
  open: false,
  severity: 'info',
  message: '',
} as const

export const FlashProvider = ({ children }: FlashProviderProps) => {
  const [state, setState] = useState<State>(defaultState)

  const showSuccessFlash = useCallback((message: string) => {
    setState({ open: true, severity: 'success', message })
  }, [])

  const showErrorFlash = useCallback((message: string) => {
    setState({ open: true, severity: 'error', message })
  }, [])

  const handleClose = useCallback(() => {
    setState(defaultState)
  }, [])

  return (
    <FlashContext.Provider value={{ showSuccessFlash, showErrorFlash }}>
      {children}
      <Flash
        open={state.open}
        severity={state.severity}
        message={state.message}
        onClose={handleClose}
      />
    </FlashContext.Provider>
  )
}
